import { analyticsFEA } from "src/AnalyticsFEA";
import signIn from "src/sdk/signIn";
import { Store } from "src/store";
import { postDealRequest } from "src/store/actions/deal";
import { toggleModal } from "src/store/actions/openModal";
import { patchTrackingRequest } from "src/store/actions/tracking";
import { deleteVehicleRequest, postVehicleRequest } from "src/store/actions/vehicles";
import { shouldCleanUpVehiclesOnOpen } from "src/store/selectors/onlineShopper";
import { PaymentTypeOptions } from "Types/state";

async function toggleOS(store: Store, vin?: string, paymentType?: PaymentTypeOptions) {
    const state = store.getState();

    // If we don't have a deal yet and we weren't toggled open with a vin, treat this like window.OnlineShopper.SignIn()
    if (!state?.deal?.uuid && !vin) {
        signIn(store);
        return;
    }

    if (!state?.onlineShopper?.isAppOpen) {
        // Open the modal fist so that the user isn't waiting on network requests
        void store.dispatch(toggleModal("sm", vin));
    }

    // Handle adding a vehicle to an existing deal
    if (state.deal.uuid && vin) {
        // If the user has not created a garage yet, clean up any vehicles other than the current vin after
        // the postVehicleRequests completes successfully (handled in the addVehicle function)
        const postVehicleRequestCallback = shouldCleanUpVehiclesOnOpen(state)
            ? () =>
                  state.vehicles.order
                      .filter((v) => v !== vin)
                      .forEach((v) => {
                          void store.dispatch(deleteVehicleRequest(state.deal.uuid as string, v));
                      })
            : undefined;
        // postVehicleRequest updated with a sequential callback
        await store.dispatch(
            postVehicleRequest(state.deal.uuid, vin, state.vehicles.entities, paymentType, postVehicleRequestCallback),
        );

        void store.dispatch(patchTrackingRequest(state.tracking, state.deal.uuid));
    }

    // Handle creating a new deal
    if (!state.deal.uuid) {
        await store.dispatch(
            postDealRequest(state.onlineShopper.env, state.account.slug, state.tracking, vin!, paymentType),
        );
    }

    const {
        deal: { uuid },
        vehicles: { entities },
    } = store.getState();

    analyticsFEA.engine.opened(vin!);
}

export default toggleOS;
